<template>
  <div>
    <page-title icon="fa fa-leaf" main="Curva ABC" sub="Curva ABC"
    :help="true"
    titleHelp="Ajuda - Curva ABC"
    content="Responsável por listar e cadastrar Pedidos permitindo filtros por Cliente e Status do Pedido.
Para criação de um pedido pressione o botão no canto superior direito 'Cadastro de Pedido'.
Para alteração de uma Campanha basta ir com o mouse em ações e clicar em Editar.">
      <template v-slot:actions>
        <base-button @click="modal0 = true" type="neutral" class="ml-3" size="sm">Novo Parâmetro</base-button>
      </template>
    </page-title>
    <!-- Inicio da modal0 -->
    <modal :show.sync="modal0">
      <validation-observer ref="observer">
        <form class="new-event--form" ref="form">
          <div class="row">
            <div class="col-lg-6">
              <label class="form-control-label d-block mb-3">Escolha o Campo</label>
              <multiselect
                v-model="selecionar"
                :options="curvaABC"
                placeholder="Escolha o campo"
                rules="required"
                label="parametro"
                :select-label="''"
                :deselect-label="''"
                :selected-label="'Selecionado'"
                track-by="id"
              ></multiselect>
            </div>
            <div class="col-lg-6">
              <base-input
                label="Parâmetros de A"
                mask="integer"
                placeholder="Parâmetros de A"
                v-model="currentBoundary_a"
                aria-label="Parâmetros de A"
                :rules="'required|integer'"
                :min="0"
              ></base-input>
            </div>
            <div class="col-lg-6">
              <base-input
                :valid="true"
                mask="integer"
                placeholder="Parâmetros de B"
                v-model="currentBoundary_b"
                aria-label="Parâmetros de B"
                label="Parâmetros de B"
                :rules=" {required: true, integer: true, validate_max: {previousValue: currentBoundary_a} }"
                :min="0"
                :max="currentBoundary_a -1"
              ></base-input>
            </div>
            <div class="col-lg-6">
              <base-input
                :valid="true"
                mask="integer"
                placeholder="Parâmetros de C"
                v-model="currentBoundary_c"
                aria-label="Parâmetros de C"
                label="Parâmetros de C"
                :rules="{ required: true, integer: true, validate_max: { previousValue: currentBoundary_b } }"
                :min="0"
                :max="currentBoundary_b -1"
              ></base-input>
            </div>
            <div class="col-lg-6">
              <base-input
                :valid="true"
                mask="integer"
                placeholder="Parâmetros de D"
                v-model="currentBoundary_d"
                aria-label="Parâmetros de D"
                label="Parâmetros de D"
                :rules=" {required: true, integer: true, validate_max: {previousValue: currentBoundary_c} }"
                :min="0"
                :max="currentBoundary_c -1"
              ></base-input>
            </div>
            <div class="col-lg-6">
              <base-input
                :valid="true"
                mask="integer"
                placeholder="Parâmetros de E"
                v-model="currentBoundary_e"
                aria-label="Parâmetros de E"
                label="Parâmetros de E"
                :rules=" {required: true, integer: true, validate_max: {previousValue: currentBoundary_d} }"
                :min="0"
                :max="currentBoundary_d -1"
              ></base-input>
            </div>
          </div>
        </form>
      </validation-observer>
      <!-- Botão adicionar (fix)-->
      <template slot="footer">
        <base-button type="secundary" @click="modal0 = false">Cancelar</base-button>
        <button
          type="submit"
          class="btn btn-primary new-event--add"
          @click="editCurv_abc()"
        >Adicionar Configuração</button>
      </template>
    </modal>
    <!-- Fim da modal0 -->
    <!-- Inicio dos cards -->
    <div class="row">
      <div class="col-xl-4 col-md-4">
        <card cardClasses="card-stats">
          <div class="row">
            <div class="col">
              <h5 class="card-title text-uppercase text-muted mb-0 bottom-margin">Areas Cadastradas</h5>
              <base-button size="sm" type="neutral" @click="filterArea = 'A'">A</base-button>
              <base-button size="sm" type="neutral" @click="filterArea = 'B'">B</base-button>
              <base-button size="sm" type="neutral" @click="filterArea = 'C'">C</base-button>
              <base-button size="sm" type="neutral" @click="filterArea = 'D'">D</base-button>
              <base-button size="sm" type="neutral" @click="filterArea = 'E'">E</base-button>
              <base-button size="sm" type="neutral" @click="getClients()">Todos</base-button>
            </div>
            <div class="col-auto">
              <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-green">
                <span>A</span>
              </div>
            </div>
          </div>
        </card>
      </div>
      <div class="col-xl-4 col-md-4">
        <card cardClasses="card-stats">
          <div class="row">
            <div class="col">
              <h5 class="card-title text-uppercase text-muted mb-0 bottom-margin">Faturamento Mensal</h5>
              <base-button size="sm" type="neutral" @click="filterFaturamento = 'A'">A</base-button>
              <base-button size="sm" type="neutral" @click="filterFaturamento = 'B'">B</base-button>
              <base-button size="sm" type="neutral" @click="filterFaturamento = 'C'">C</base-button>
              <base-button size="sm" type="neutral" @click="filterFaturamento = 'D'">D</base-button>
              <base-button size="sm" type="neutral" @click="filterFaturamento = 'E'">E</base-button>
              <base-button size="sm" type="neutral" @click="getClients()">Todos</base-button>
            </div>
            <div class="col-auto">
              <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-orange">
                <span>F</span>
              </div>
            </div>
          </div>
        </card>
      </div>
      <div class="col-xl-4 col-md-4">
        <card cardClasses="card-stats">
          <div class="row">
            <div class="col">
              <h5 class="card-title text-uppercase text-muted mb-0 bottom-margin">Margem</h5>
              <base-button size="sm" type="neutral" @click="filterMargem = 'A'">A</base-button>
              <base-button size="sm" type="neutral" @click="filterMargem = 'B'">B</base-button>
              <base-button size="sm" type="neutral" @click="filterMargem = 'C'">C</base-button>
              <base-button size="sm" type="neutral" @click="filterMargem = 'D'">D</base-button>
              <base-button size="sm" type="neutral" @click="filterMargem = 'E'">E</base-button>
              <base-button size="sm" type="neutral" @click="getClients()">Todos</base-button>
            </div>
            <div class="col-auto">
              <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-red">
                <span>M</span>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
    <!-- Fim dos cards -->
    <!-- inicio dos collapse -->

    <div class="row">
      <collapse class="col-xl-12">
        <collapse-item @click="getClients()">
          <div slot="title" class="row">
            <div class="col-md-3">
              <strong class="title">Área</strong>
            </div>
            <div class="col-md-6 ajuste">
              <strong>A:</strong>
              {{collapseTitleArea[0]}}%
              <strong>B:</strong>
              {{collapseTitleArea[1]}}%
              <strong>C:</strong>
              {{collapseTitleArea[2]}}%
              <strong>D:</strong>
              {{collapseTitleArea[3]}}%
              <strong>E:</strong>
              {{collapseTitleArea[4]}}%
            </div>
            <div class="col-md-3">
              <strong>Total:</strong>
              {{collapseTitleArea[5]}}
            </div>
          </div>
          <div>
            <el-table header-row-class-name="thead-light" :data="filteredClientsArea">
              <el-table-column
                label="Nome dos Clientes"
                min-width="200px"
                prop="razao_social"
                sortable
              ></el-table-column>
              <el-table-column label="Área" min-width="150px" prop="culture_ids[0].culture_area" sortable></el-table-column>
              <el-table-column label="Tipo" min-width="100px" prop="see_type_area" sortable></el-table-column>
            </el-table>
            <div class="card-footer py-4 d-flex justify-content-end">
              <base-pagination
                v-on:input="getClients(pagination.current)"
                v-model="pagination.current"
                :total="pagination.count"
                :perPage="pagination.per_page"
              >
              </base-pagination>
            </div>
          </div>
        </collapse-item>
      </collapse>
    </div>

    <div class="row">
      <collapse class="col-xl-12">
        <collapse-item @click="getClients()">
          <div slot="title" class="row">
            <div class="col-md-3">
              <strong class="title">Faturamento</strong>
            </div>
            <div class="col-md-6 ajuste">
              <strong>A:</strong>
              {{collapseTitleFaturamento[0]}}%
              <strong>B:</strong>
              {{collapseTitleFaturamento[1]}}%
              <strong>C:</strong>
              {{collapseTitleFaturamento[2]}}%
              <strong>D:</strong>
              {{collapseTitleFaturamento[3]}}%
              <strong>E:</strong>
              {{collapseTitleFaturamento[4]}}%
            </div>
            <div class="col-md-3">
              <strong>Total:</strong>
              {{collapseTitleFaturamento[5]}}
            </div>
          </div>
          <div>
            <el-table header-row-class-name="thead-light" :data="filteredClientsFaturamento">
              <el-table-column
                label="Nome do cliente"
                min-width="200px"
                prop="razao_social"
                sortable
              ></el-table-column>

              <el-table-column label="Faturamento" min-width="150px" sortable v-slot="{row}">
                <span>{{row.revenue_see.toLocaleString('pt-BR', {style: 'currency', currency: 'brl'})}}</span>
              </el-table-column>
              <el-table-column label="Tipo" min-width="100px" prop="see_type_revenue" sortable></el-table-column>
            </el-table>
            <div class="card-footer py-4 d-flex justify-content-end">
              <base-pagination
                v-on:input="getClients(pagination.current)"
                v-model="pagination.current"
                :total="pagination.count"
                :perPage="pagination.per_page"
              >
              </base-pagination>
            </div>
          </div>
        </collapse-item>
      </collapse>
    </div>

    <div class="row">
      <collapse class="col-xl-12">
        <collapse-item :title="collapseTitleMargem.join(',')" @click="getClients()">
          <div slot="title" class="row">
            <div class="col-md-3">
              <strong class="title">Margem</strong>
            </div>
            <div class="col-md-6 ajuste">
              <strong>A:</strong>
              {{collapseTitleMargem[0]}}%
              <strong>B:</strong>
              {{collapseTitleMargem[1]}}%
              <strong>C:</strong>
              {{collapseTitleMargem[2]}}%
              <strong>D:</strong>
              {{collapseTitleMargem[3]}}%
              <strong>E:</strong>
              {{collapseTitleMargem[4]}}%
            </div>
            <div class="col-md-3">
              <strong>Total:</strong>
              {{collapseTitleMargem[5]}}
            </div>
          </div>
          <div>
            <el-table header-row-class-name="thead-light" :data="filteredClientsMargem">
              <el-table-column
                label="Nome do cliente"
                min-width="200px"
                prop="razao_social"
                sortable
              ></el-table-column>

              <el-table-column label="Margem" min-width="150px" sortable v-slot="{row}">
                <span>{{row.revenue_see.toLocaleString('pt-BR', {style: 'currency', currency: 'brl'})}}</span>
              </el-table-column>
              <el-table-column label="Tipo" min-width="100px" prop="see_type_margin" sortable></el-table-column>
            </el-table>
            <div class="card-footer py-4 d-flex justify-content-end">
              <base-pagination
                v-on:input="getClients(pagination.current)"
                v-model="pagination.current"
                :total="pagination.count"
                :perPage="pagination.per_page"
              >
              </base-pagination>
            </div>
          </div>
        </collapse-item>
      </collapse>
    </div>

    <!-- Fim dos collapse -->
  </div>
</template>
<script>
import PageTitle from "@/layouts/PageTitle";
import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import Modal from "@/components/Modal";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import { Table, TableColumn } from "element-ui";
import { ValidationProvider, extend } from "vee-validate";
import { required, min, min_value, max_value } from "vee-validate/dist/rules";
import { max } from "date-fns";
extend("required", {
  ...required,
  message: "Este campo é obrigatório",
});
extend("max_value", {
  ...max,
  message: "O valor deve ser menor que o anterior ",
});
extend("integer", {
  validate: value => Number.isInteger(value) && value >= 0,
  message: "O valor deve ser um número válido",
});
extend("validate_max", {
  params: ["previousValue"],
  validate(value, { previousValue }) {
    return value < previousValue
  },
  message: "O valor deve ser menor que o anterior",
})

export default {
  components: {
    PageTitle,
    Collapse,
    ValidationProvider,
    CollapseItem,
    Multiselect,
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      curvaABC: [],
      selecionar: [],
      modal0: false,
      filterArea: "",
      pagination: {
        current: 1,
        count: 0,
        per_page: 20,
      },
      percentAreaA: "",
      percentAreaB: "",
      percentAreaC: "",
      percentAreaD: "",
      percentAreaE: "",
      percentFaturamentoA: "",
      percentFaturamentoB: "",
      percentFaturamentoC: "",
      percentFaturamentoD: "",
      percentFaturamentoE: "",
      percentMargemA: "",
      percentMargemB: "",
      percentMargemC: "",
      percentMargemD: "",
      percentMargemE: "",
      filterFaturamento: "",
      filterMargem: "",
      clients: [],
      filteredClientsArea: [],
      filteredTipoAreaA: [],
      filteredTipoAreaB: [],
      filteredTipoAreaC: [],
      filteredTipoAreaD: [],
      filteredTipoAreaE: [],
      filteredTipoFaturamentoA: [],
      filteredTipoFaturamentoB: [],
      filteredTipoFaturamentoC: [],
      filteredTipoFaturamentoD: [],
      filteredTipoFaturamentoE: [],
      filteredTipoMargemA: [],
      filteredTipoMargemB: [],
      filteredTipoMargemC: [],
      filteredTipoMargemD: [],
      filteredTipoMargemE: [],
      filteredClientsFaturamento: [],
      filteredClientsMargem: [],
      currentBoundary_a: "",
      currentBoundary_b: "",
      currentBoundary_c: "",
      currentBoundary_d: "",
      currentBoundary_e: "",
    };
  },
  methods: {
    getClients(page) {
      const data = {
        page: page || 1,
        per_page: this.pagination.per_page,
      }
      this.$http.secured.get("/api/v1/clients", { params: data}).then((response) => {
        this.clients = response.data["clients"];
        this.pagination.per_page = response.data["per_page"];
        this.pagination.count = response.data["count"];
        this.filteredClientsArea = this.clients;
        this.filteredClientsFaturamento = this.clients;
        this.filteredClientsMargem = this.clients;
        this.filterClientTipo = this.clients;
        this.percent_abc();
      });
    },
    getCurve_abc() {
      this.$http.secured
        .get("/api/v1/abc_curves", {})
        .then((response) => {
          this.curvaABC = response.data;
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    percent_abc() {
      //Codigo referente a Tipo da Area e sua porcentagem

      this.filteredTipoAreaA = this.clients.filter(function (element) {
        var valorA = element.see_type_area == "A";

        return valorA;
      });
      this.filteredTipoAreaB = this.clients.filter(function (element) {
        var valorB = element.see_type_area == "B";

        return valorB;
      });
      this.filteredTipoAreaC = this.clients.filter(function (element) {
        var valorC = element.see_type_area == "C";

        return valorC;
      });
      this.filteredTipoAreaD = this.clients.filter(function (element) {
        var valorD = element.see_type_area == "D";

        return valorD;
      });
      this.filteredTipoAreaE = this.clients.filter(function (element) {
        var valorE = element.see_type_area == "E";

        return valorE;
      });

      this.percentAreaA =
        (this.filteredTipoAreaA.length / this.clients.length) * 100;

      this.percentAreaB =
        (this.filteredTipoAreaB.length / this.clients.length) * 100;

      this.percentAreaC =
        (this.filteredTipoAreaC.length / this.clients.length) * 100;

      this.percentAreaD =
        (this.filteredTipoAreaD.length / this.clients.length) * 100;

      this.percentAreaE =
        (this.filteredTipoAreaE.length / this.clients.length) * 100;

      //Codigo referente a Tipo do Faturamento e sua porcentagem

      this.filteredTipoFaturamentoA = this.clients.filter(function (element) {
        var valorFaturaA = element.see_type_revenue == "A";

        return valorFaturaA;
      });
      this.filteredTipoFaturamentoB = this.clients.filter(function (element) {
        var valorFaturaB = element.see_type_revenue == "B";

        return valorFaturaB;
      });
      this.filteredTipoFaturamentoC = this.clients.filter(function (element) {
        var valorFaturaC = element.see_type_revenue == "C";

        return valorFaturaC;
      });
      this.filteredTipoFaturamentoD = this.clients.filter(function (element) {
        var valorFaturaD = element.see_type_revenue == "D";

        return valorFaturaD;
      });
      this.filteredTipoFaturamentoE = this.clients.filter(function (element) {
        var valorFaturaE = element.see_type_revenue == "E";

        return valorFaturaE;
      });

      this.percentFaturamentoA =
        (this.filteredTipoFaturamentoA.length / this.clients.length) * 100;

      this.percentFaturamentoB =
        (this.filteredTipoFaturamentoB.length / this.clients.length) * 100;

      this.percentFaturamentoC =
        (this.filteredTipoFaturamentoC.length / this.clients.length) * 100;

      this.percentFaturamentoD =
        (this.filteredTipoFaturamentoD.length / this.clients.length) * 100;

      this.percentFaturamentoE =
        (this.filteredTipoFaturamentoE.length / this.clients.length) * 100;

      //Codigo referente a Tipo da Margem e sua porcentagem

      this.filteredTipoMargemA = this.clients.filter(function (element) {
        var valorMargemA = element.see_type_margin == "A";

        return valorMargemA;
      });
      this.filteredTipoMargemB = this.clients.filter(function (element) {
        var valorMargemB = element.see_type_margin == "B";

        return valorMargemB;
      });
      this.filteredTipoMargemC = this.clients.filter(function (element) {
        var valorMargemC = element.see_type_margin == "C";

        return valorMargemC;
      });
      this.filteredTipoMargemD = this.clients.filter(function (element) {
        var valorMargemD = element.see_type_margin == "D";

        return valorMargemD;
      });
      this.filteredTipoMargemE = this.clients.filter(function (element) {
        var valorMargemE = element.see_type_margin == "E";

        return valorMargemE;
      });

      this.percentMargemA =
        (this.filteredTipoMargemA.length / this.clients.length) * 100;

      this.percentMargemB =
        (this.filteredTipoMargemB.length / this.clients.length) * 100;

      this.percentMargemC =
        (this.filteredTipoMargemC.length / this.clients.length) * 100;

      this.percentMargemD =
        (this.filteredTipoMargemD.length / this.clients.length) * 100;

      this.percentMargemE =
        (this.filteredTipoMargemE.length / this.clients.length) * 100;
    },
    validForm() { 
      const validForm = this.$refs.observer.validate()
      if (!validForm) return false;

      return this.currentBoundary_a > this.currentBoundary_b &&
          this.currentBoundary_b > this.currentBoundary_c &&
          this.currentBoundary_c > this.currentBoundary_d &&
          this.currentBoundary_d > this.currentBoundary_e
    },
    async editCurv_abc() {
      if (!this.validForm()) return (this.modal0 = true);

      try {
        const response = await this.$http.secured
        .put(`/api/v1/abc_curves/${this.selecionar.id}`, {
          abc_curve: {
            id: this.selecionar.id,
            boundary_a: this.currentBoundary_a,
            boundary_b: this.currentBoundary_b,
            boundary_c: this.currentBoundary_c,
            boundary_d: this.currentBoundary_d,
            boundary_e: this.currentBoundary_e,
          }
        })
        this.modal0 = false;
        this.getClients();
        this.clearForm()

      } catch (error) {
          console.warn("Error setting ABC values", error)
      }
    },
    clearForm() {
      this.selecionar = [];
      this.currentBoundary_a = "";
      this.currentBoundary_b = "";
      this.currentBoundary_c = "";
      this.currentBoundary_d = "";
      this.currentBoundary_e = "";

      this.$refs.observer.reset();
    },
  },
  mounted() {
    this.getClients();
    this.getCurve_abc();
  },
  computed: {
    collapseTitleArea() {
      return [
        this.percentAreaA,
        this.percentAreaB,
        this.percentAreaC,
        this.percentAreaD,
        this.percentAreaE,
        this.clients.length,
      ];
    },

    collapseTitleFaturamento() {
      return [
        this.percentFaturamentoA,
        this.percentFaturamentoB,
        this.percentFaturamentoC,
        this.percentFaturamentoD,
        this.percentFaturamentoE,
        this.clients.length,
      ];
    },

    collapseTitleMargem() {
      return [
        this.percentMargemA,
        this.percentMargemB,
        this.percentMargemC,
        this.percentMargemD,
        this.percentMargemE,
        this.clients.length,
      ];
    },
  },
  watch: {
    filterArea: function (valueArea) {
      this.filteredClientsArea = this.clients.filter(function (element) {
        return element.see_type_area == valueArea;
      });
    },
    filterFaturamento: function (valueFaturamento) {
      this.filteredClientsFaturamento = this.clients.filter(function (element) {
        return element.see_type_revenue == valueFaturamento;
      });
    },
    filterMargem: function (valueMargem) {
      this.filteredClientsMargem = this.clients.filter(function (element) {
        return element.see_type_margin == valueMargem;
      });
    },
  },
};
</script>
<style>
.bottom-margin {
  margin-bottom: 10px !important;
}
.center {
  font-size: 18px;
  font-weight: bold;
}
.title {
  text-align: left;
}
.ajuste {
  text-align: center;
}
</style>
